// extracted by mini-css-extract-plugin
export default {"account_form":"verificationForm_account_form__faIL6","button":"verificationForm_button__uzQEx"};